module["exports"] = [
  "rood",
  "groen",
  "blauw",
  "koningblauw",
  "geel",
  "purper",
  "muntgroen",
  "groenblauw",
  "wit",
  "zwart",
  "oranje",
  "roze",
  "grijs",
  "donkergrijs",
  "oker",
  "terracotta",
  "kastanjebruin",
  "paars",
  "turkoois",
  "bruin",
  "hemelsblauw",
  "zalmroze",
  "oudroze",
  "appelgroen",
  "levend wit",
  "olijfgroen",
  "magenta",
  "limoen",
  "ivoor",
  "indigo",
  "goud",
  "fuchsia",
  "cyaan",
  "azuurblauw",
  "lavendel",
  "zilver"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/nl/commerce/color.js
// module id = 3286
// module chunks = 1610